import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  Permission,
  PermissionResourceType,
} from '../../models/permission.model';
import { ENDPOINTS } from '../../constants/endpoints.constants';
import { ApiResponse } from '../../models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class PermissionResourceService {
  private readonly http = inject(HttpClient);

  getPermissionsResource(resourceType: PermissionResourceType) {
    const url = ENDPOINTS.Application.Permission.Resource.replace(
      '{resourceType}',
      resourceType
    );
    return this.http.get<ApiResponse<Permission>>(url);
  }
}
